import { render } from "./CollaborationsComponent.vue?vue&type=template&id=584ff815&ts=true"
import script from "./CollaborationsComponent.vue?vue&type=script&lang=ts"
export * from "./CollaborationsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__